import React, { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext();

const MAX_SEGMENTS = 5;
const MAX_LABEL_LENGTH = 50;

/**
 * Truncates a label to the maximum allowed length with ellipsis.
 * Applied at registration time to enforce the 50-character limit.
 */
const truncateSegmentLabel = (label) => {
  if (!label || label.length <= MAX_LABEL_LENGTH) return label;
  return label.substring(0, MAX_LABEL_LENGTH) + '…';
};

/**
 * Processes segments to enforce label truncation and max segment count.
 */
const processSegments = (segments) => {
  if (!Array.isArray(segments)) return [];

  const truncated = segments.slice(0, MAX_SEGMENTS);

  return truncated.map((segment) => ({
    ...segment,
    label: truncateSegmentLabel(segment.label),
  }));
};

export const useBreadcrumbs = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbProvider');
  }
  return context;
};

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbsState] = useState([]);

  const setBreadcrumbs = useCallback((segments) => {
    setBreadcrumbsState(processSegments(segments));
  }, []);

  const clearBreadcrumbs = useCallback(() => {
    setBreadcrumbsState([]);
  }, []);

  return (
    <BreadcrumbContext.Provider value={{
      breadcrumbs,
      setBreadcrumbs,
      clearBreadcrumbs
    }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};
